import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Abstract polymorphic resource for the `commentable` role. Concrete types
// (company, employee, tas-application, tas-program-instance, ...) gain the
// `comments` relationship via `traits: ['commentable']`; this resource exists
// so the polymorphic `comment.commentable` target type resolves through the
// schema service. Without it, `schema.fields({ type: 'commentable' })` misses
// the resource registry and recurses into the legacy ModelSchemaProvider /
// ShimModelClass (RangeError: Maximum call stack size exceeded). Mirrors the
// owner/messageable abstract-resource pattern.
const CommentableSchema = withDefaults({
  type: 'commentable',
  fields: [
    {
      kind: 'hasMany',
      name: 'comments',
      type: 'comment',
      options: {
        async: false,
        inverse: 'commentable',
        as: 'commentable',
      },
    },
  ],
});

export default CommentableSchema;
